export default __webpack_public_path__ + "static/Witcher-91cf8da892cfdb10662a46076a921228.png";